export const stringsKey = "LogRequestForHelp";
export const englishStrings = {
	callbackURL: "Callback URL",
	successTextMessage: "Success Text Message",
	successAudioFile: "Success Audio File",
	errorTextMessage: "Error Text Message",
	errorAudioFile: "Error Audio File",
	callbackURLErrorMessage: "The Callback URL field is required.",
	logTimeouts: "Log Timeouts",
	timeoutCallbackURL: "Timeout Callback URL",
	timeoutCallbackURLErrorMessage: "The Timeout Callback URL field is required.",
};
